export default __webpack_public_path__ + "static/media/polly-icon.fffc0cf6.svg";